module.exports = __webpack_public_path__ + "static/media/bgcourse.76713036.jpg";